import { DirectionalHint, TooltipHost, ZIndexes } from "@fluentui/react";
import React, { useContext, useMemo } from "react";
import themeContext from "../../context/theme/ThemeContext";

const CustomToolTipHost = (props) => {
  const { getThemeColor } = useContext(themeContext);

  const styles =
    props.styles != undefined && props.styles != null ? props.styles : {};
  const content = props.content;
  const id = props.id != null && props.id != undefined ? props.id : "random_";
  const directionalHint =
    props.directionalHint != null && props.directionalHint != undefined
      ? true
      : false;

  // Memoized to prevent new object references on every render, which would
  // cause FluentUI Callout to reschedule a position update (setState) each
  // time, creating an infinite update loop during window resize.
  const toolTipProps = useMemo(() => {
    if (props.toolTipProps != undefined && props.toolTipProps != null) {
      return props.toolTipProps;
    }
    return {
      calloutProps: {
        styles: {
          beak: { background: getThemeColor("tooltip") },
          beakCurtain: { background: getThemeColor("tooltip") },
          calloutMain: { background: getThemeColor("tooltip") },
          borderRadius: "5px",
          boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
        },
      },
    };
  }, [props.toolTipProps, getThemeColor]);

  return directionalHint ? (
    <TooltipHost
      styles={styles}
      content={content}
      id={id}
      tooltipProps={toolTipProps}
      closeDelay={props.closeDelay}
      directionalHint={props.directionalHint}
    >
      {props.children}
    </TooltipHost>
  ) : (
    <TooltipHost
      styles={styles}
      content={content}
      id={id}
      tooltipProps={toolTipProps}
      closeDelay={props.closeDelay}
    >
      {props.children}
    </TooltipHost>
  );
};

export default CustomToolTipHost;
